import React from "react";
import "./pagination.css";

const TablePagination = ({ page = 1, totalPages = 1, onPageChange }) => {
  if (totalPages <= 1 || typeof onPageChange !== "function") {
    return null;
  }

  const goToPage = (p) => {
    if (p < 1 || p > totalPages) return;
    onPageChange(p);
  };

  return (
    <div className="pagination-wrapper">
      <button
        className="nav-btn"
        disabled={page === 1}
        onClick={() => goToPage(page - 1)}
      >
        <i className="ri-arrow-left-s-line" />
      </button>

      {[...Array(totalPages)].map((_, i) => {
        const p = i + 1;
        return (
          <button
            key={p}
            className={`page-btn ${page === p ? "active" : ""}`}
            onClick={() => goToPage(p)}
          >
            {p}
          </button>
        );
      })}

      <button
        className="nav-btn"
        disabled={page === totalPages}
        onClick={() => goToPage(page + 1)}
      >
        <i className="ri-arrow-right-s-line" />
      </button>
    </div>
  );
};

export default TablePagination;
